export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Banque Premium",
  headline: "Transactions illimitées sans frais",
  description:
    "Accédez à notre application et envoyez vos virements sans limite et sans aucun frais.",
  buttonLabel: "J'y vais",
  imgStart: false,
  img: require("../../images/svg-1.svg").default,
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};

export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Accès Illimité",
  headline: "Consultez votre compte à toute heure",
  description:
    "Nous sommes là pour vous, où que vous soyez. Une connexion internet, votre smartphone ou ordinateur et le tour est joué.",
  buttonLabel: "En savoir plus",
  imgStart: true,
  img: require("../../images/svg-6.svg").default,
  alt: "Piggybank",
  dark: false,
  primary: false,
  darkText: true,
};

export const homeObjThree = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Rejoignez-nous",
  headline: "Créer un compte est extrêmement facile",
  description:
    "Entrez vos informations et tout sera prêt en moins de 10 minutes.",
  buttonLabel: "Je m'inscris",
  imgStart: false,
  img: require("../../images/svg-7.svg").default,
  alt: "account",
  dark: false,
  primary: false,
  darkText: true,
};
